"use client";
import { CohesionProvider, useMonarchRule } from "@redventures/cohesion-utils-react";
import styles from "./Hero.module.scss";

interface HeroProps {
  sectionId: string;
  formHref: string;
  background: string;
  customCss?: string;
  header: string;
  subheader?: string;
  description?: string;
  buttonLabel: string;
  buttonColor: string;
  buttonTextColor?: string;
  school: string;
}

const Hero = function ({
  sectionId,
  formHref,
  background,
  customCss,
  header,
  subheader,
  description,
  buttonLabel,
  buttonColor,
  buttonTextColor,
  school,
}: HeroProps) {
  const { value } = useMonarchRule(school, {
    default: {
      data: { cta: buttonLabel },
    },
  });
  const handleScroll = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const ExecedLeadForm = document.querySelector(formHref);
    if (ExecedLeadForm) {
      ExecedLeadForm.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {customCss && <style>{customCss}</style>}
      <section id={sectionId} className={`${styles.hero} execed-hero-section`} style={{ background }}>
        <div className={`${styles.heroContainer} execed-hero-container`}>
          <h1 dangerouslySetInnerHTML={{ __html: header }} />
          {subheader && <small dangerouslySetInnerHTML={{ __html: subheader }} />}
          {description && <p dangerouslySetInnerHTML={{ __html: description }} />}
          <a
            className={`${styles.heroButton} execed-hero-cta`}
            href={formHref}
            onClick={handleScroll}
            id="cta-scroll"
            style={{
              backgroundColor: buttonColor,
              border: `2px solid ${buttonColor}`,
              color: buttonTextColor || "#fff",
            }}
          >
            {value?.data?.cta || buttonLabel}
          </a>
        </div>
      </section>
    </>
  );
};

export const ExecedHero = (props: HeroProps) => {
  return (
    <CohesionProvider>
      <Hero {...props} />
    </CohesionProvider>
  );
};
